<template>
<div class="chapter">
<div class="inner_page">
<div class="figcenter1" id="frontispiz">
<img alt="Frontispiz: Sven Hedin in   kaiserlicher Uniform" class="w" id="id-3064535589832948675" src="Images/img0001.jpg"/>
<div class="linkedimage"><span id="frontispiz_gross">⇒<br class="calibre8"/>
<span class="s1">GRÖSSERES BILD</span></span></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?969c9eb6